<template>
    <tr>
        <td :class="{'action-cell' : isMobile}">
          <router-link :to="{ name: 'therapist-edit', params: { therapistId: item.id }}">
            <div class="icon-circle icon-indigo">
              <span class="text-uppercase" v-if="!isMobile">{{item.displayName| toFirstLetter}}</span>
            </div>

            <strong v-if="!isMobile">{{item.displayName}}</strong>
          </router-link>
        </td>
        <td v-if="isMobile">
          <router-link :to="{ name: 'therapist-edit', params: { therapistId: item.id }}">
            <strong>{{item.displayName}}
            </strong>
          </router-link>
        </td>
        <td class="text-center">
            {{item.clientsCount}}
        </td>
        <td class="text-center">
            {{item.bidsOnWorkCount}}
        </td>
        <td class="table-actions" v-if="!isMensurationForbidden">
            <a class="delete-icon" @click.prevent="deleteItem">
                <mdc-icon icon="delete"></mdc-icon>
            </a>

        </td>
    </tr>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    props: {
      item: Object,
    },
    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('auth', [
        'isMensurationForbidden',
      ]),
    },
    methods: {
      close() {
        this.isOpen = false;
      },
      deleteItem() {
        this.close();
        this.$emit('deleteItem', this.item.id);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/user/curator/profile/components/list/TherapistItem.vue